import {Suspense} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomButtonShapes} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import MoleculeSelectPopover, {selectPopoverOverlayTypes} from '@s-ui/react-molecule-select-popover'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import ChevronRight from '@adv-mt/mt-svg-icons/lib/ChevronRight.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {BASE_CLASS, DESIGNS} from '../../config.js'
import FormLocationContent from '../Content/index.js'
import useLabel from './useLabel.js'

const FormLocationPopover = ({aggregations, design, isLoading, onChange, overlayContentRef, search}) => {
  const {domain, i18n} = useSuiContext()
  const {label} = useLabel({search})

  const config = domain.get('config')
  const {DEFAULT_FILTERS_SEARCH, FILTER_NAMES} = config.get('searchFilters')

  const popoverClassNames = cx(`${BASE_CLASS}Popover`, design && `${BASE_CLASS}Popover--${design}`)

  const isRightPopoverDesign = design === DESIGNS.RIGHT_POPOVER

  const hasSelections = Boolean(search.location.text) || search.provinceIds.length

  const handleResetFilter = () => {
    onChange(null, {
      field: search.provinceIds.length ? FILTER_NAMES.PROVINCE : FILTER_NAMES.LOCATION,
      value: search.provinceIds.length ? DEFAULT_FILTERS_SEARCH.provinceIds : DEFAULT_FILTERS_SEARCH.location
    })
  }

  return (
    <div className={popoverClassNames}>
      <MoleculeSelectPopover
        acceptButtonOptions={{isLoading, shape: atomButtonShapes.CIRCULAR}}
        acceptButtonText={i18n.t('COMMON.ACCEPT')}
        cancelButtonOptions={{shape: atomButtonShapes.CIRCULAR}}
        cancelButtonText={i18n.t('COMMON.CANCEL')}
        fullWidth
        iconArrowDown={isRightPopoverDesign ? ChevronRight : ChevronDown}
        isSelected={hasSelections}
        overlayContentRef={overlayContentRef}
        overlayType={selectPopoverOverlayTypes.LIGHT}
        removeButtonOptions={{
          isShown: hasSelections,
          onClick: handleResetFilter,
          rightIcon: IconClose,
          shape: atomButtonShapes.SQUARED
        }}
        selectText={label}
      >
        <Suspense fallback={<div style={{height: '400px'}} />}>
          <div className={`${BASE_CLASS}Popover-wrapper`}>
            <FormLocationContent
              aggregations={aggregations}
              autoFocus
              isLoading={isLoading}
              onChange={onChange}
              search={search}
            />
          </div>
        </Suspense>
      </MoleculeSelectPopover>
    </div>
  )
}

FormLocationPopover.displayName = 'FormLocationPopover'
FormLocationPopover.propTypes = {
  aggregations: PropTypes.array,
  design: PropTypes.string,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  search: PropTypes.object
}

export default FormLocationPopover
